import React from "react";
import styled from "styled-components";

const Footer = styled.footer`
  color: white;
  text-align: center;
  margin: 20px;
`;

const Paragraph = styled.p`
  margin: 0px;
  margin-bottom: 10px;
`;

const Link = styled.a`
  color: white;
  text-decoration: underline;
`;

export default () => (
  <Footer>
    <Paragraph>
      Race2Challenger Leaderboard is made by BangingHeads and provided
      {` by `}
      <Link href="https://twitch.tv/lolrankbot">{` LoLRankBot`}</Link>
    </Paragraph>
    <Paragraph>
      More information on the event can be found
      {` on `}
      <Link href="https://twitter.com/RTO_LOL/status/1167472665042595844">{` RTO's Twitter`}</Link>
    </Paragraph>
    <Paragraph>
      BangingHeads &amp; LoLRankBot are not affiliated with Riot Games or League
      of Legends
    </Paragraph>
  </Footer>
);
